import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { MaterialGroupsListPage } from "@/modules/stock/pages/MaterialGroupsList.page";

export const Route = createFileRoute("/__authed/m/stock/material-groups")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_material_groups")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: MaterialGroupsListPage,
});
